// extracted by mini-css-extract-plugin
export default {"IconStyling":"MJT1cmKC"};